import { useEffect, useState } from "react";
import axios from "axios";
import { Auth } from "aws-amplify";
import { API_R3API_ODOO_EXECUTE_URI } from "../Context/Constants";

const readNumericValue = (value, fallback = 0) => {
  const parsed = Number(value);
  return Number.isFinite(parsed) ? parsed : fallback;
};

const useTokenBalance = () => {
  const [tokenBalance, setTokenBalance] = useState(0);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;

    const fetchAvailableTokens = async () => {
      try {
        const session = await Auth.currentSession();
        const idTokenTrans = session.getIdToken().getJwtToken();
        const user = await Auth.currentAuthenticatedUser();
        const email = user.attributes.email;
        const headers = {
          Authorization: `Bearer ${idTokenTrans}`,
          "Content-Type": "application/json"
        };
        const resp = await axios.post(
          API_R3API_ODOO_EXECUTE_URI,
          {
            action: "gettoken",
            domain: process.env.REACT_APP_DOMAIN_PARAM,
            emailid: email
          },
          { headers }
        );
        if (!cancelled) {
          setTokenBalance(readNumericValue(resp.data?.totalquantityremaining, 0));
        }
      } catch (error) {
        console.error("Failed to fetch token balance:", error.message);
        if (!cancelled) {
          setTokenBalance(0);
        }
      } finally {
        if (!cancelled) {
          setLoading(false);
        }
      }
    };

    fetchAvailableTokens();
    return () => {
      cancelled = true;
    };
  }, []);

  return { tokenBalance, tokensLoading: loading };
};

export default useTokenBalance;
